import React from 'react';
import { shape, node, bool, oneOf, func, string } from 'prop-types';
import Dialog, { DialogContent } from 'material-ui/Dialog';
import classNames from 'classnames';
import { withStyles } from 'material-ui/styles';
import IconButton from 'material-ui/IconButton';
import Times from 'crehana-icons/Times';
import { reduceClasses } from '../utils/testUtils';

const styles = {
  noPadding: {
    padding: '0px !important',
  },
  button: {
    position: 'absolute',
    top: '9px',
    right: '9px',
  },
  whiteButton: {
    position: 'absolute',
    width: 28,
    height: 28,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#31313154',
    borderRadius: 50,
    top: '9px',
    right: '9px',
    transition: 'all ease 0.5s',
    '&:hover': {
      background: '#46464694',
      cursor: 'pointer',
    },
  },
};

const Modal = ({
  dialogClasses: dialogClassesProp,
  contentClasses: contentClassesProp,
  classes: classesProp,
  children,
  fullScreen,
  ignoreBackdropClick,
  ignoreEscapeKeyUp,
  maxWidth,
  onRequestClose,
  open,
  x,
  noPadding,
  contentClassName,
  whiteX,
  test,
  ...other
}) => {
  const dialogClasses = test && dialogClassesProp ? reduceClasses(dialogClassesProp) : dialogClassesProp;
  const contentClasses = test && contentClassesProp ? reduceClasses(contentClassesProp) : contentClassesProp;
  const classes = test ? reduceClasses(classesProp) : classesProp;

  return (
    <Dialog
      fullScreen={fullScreen}
      disableBackdropClick={ignoreBackdropClick}
      disableEscapeKeyDown={ignoreEscapeKeyUp}
      maxWidth={maxWidth}
      onClose={onRequestClose}
      open={open}
      classes={dialogClasses}
      {...other}
    >
      <DialogContent
        className={classNames({
          [classes.noPadding]: noPadding,
        }, contentClassName)}
        classes={contentClasses}
      >
        { x &&
          <IconButton className={classes.button} aria-label={'Cerrar'} onClick={onRequestClose}>
            <Times color={'#C6C6C6'} size={20} onClick={onRequestClose} />
          </IconButton>
        }
        { whiteX &&
          <span className={classes.whiteButton} aria-label={'Cerrar'} onClick={onRequestClose}>
            <Times color={'#FFF'} size={12} onClick={onRequestClose} />
          </span>
        }
        {children}
      </DialogContent>
    </Dialog>
  );
};

Modal.propTypes = {
  /** Classes from the styleSheet generated. */
  classes: shape({}).isRequired,
  /** Dialog classes */
  dialogClasses: shape({}),
  /** DialogContent classes */
  contentClasses: shape({}),
  /** Dialog children, usually the included sub-components. */
  children: node,
  /** If true, it will be full-screen. */
  fullScreen: bool,
  /** If true, clicking the backdrop will not fire the onRequestClose callback. */
  ignoreBackdropClick: bool,
  /** If true, hitting escape will not fire the onRequestClose callback. */
  ignoreEscapeKeyUp: bool,
  /**
   * Determine the max width of the dialog.
   * The dialog width grows with the size of the screen,
   * this property is useful on the desktop where you might need some coherent different width size across your application.
   */
  maxWidth: oneOf(['xs', 'sm', 'md']),
  /** Callback fired when the component requests to be closed. */
  onRequestClose: func.isRequired,
  /** If true, the Dialog is open. */
  open: bool.isRequired,
  /** Override styles for the root element. */
  style: shape({}),
  /** Show close icon. */
  x: bool,
  /** Remove padding from content wrapper. */
  noPadding: bool,
  /** extend styles for content. */
  contentClassName: string,
  /** Show close white icon with circular dark wrapper.  */
  whiteX: bool,
  /** Useful for snapshot testing. */
  test: bool,
};

Modal.defaultProps = {
  children: null,
  fullScreen: false,
  ignoreBackdropClick: false,
  ignoreEscapeKeyUp: false,
  maxWidth: 'sm',
  style: {},
  x: false,
  noPadding: false,
  contentClassName: '',
  dialogClasses: null,
  contentClasses: null,
  whiteX: false,
  test: false,
};

export default withStyles(styles, { name: 'Modal' })(Modal);
